{
	"type": "symbol",
	"minzoom": 11,
	"layout": {
		"icon-image": [
			"match",
			["get", "advisory_sign"],
			["Chevron Alignment (W1-8)", "Chevron Alignment (D4-6)"],
			"safecurves-outline:chevron",
			"safecurves-outline:advisory_sign"
		],
		"icon-size": ["match", ["get", "advisory_sign"], "Chevron Alignment (W1-8)", 0.18, 0.34],
		"icon-allow-overlap": true,
		"icon-offset": [0, -15]
	},
	"paint": {
		"icon-color": [
			"match",
			["get", "advisory_sign_recommendation"],
			"Required",
			"#e81c3a",
			"Recommended",
			"#fba824",
			"Optional",
			"#4ac40e",
			"#ddd"
		]
	}
}
